import { render, staticRenderFns } from "./changeOrder.vue?vue&type=template&id=1b938520&scoped=true&"
import script from "./changeOrder.vue?vue&type=script&lang=js&"
export * from "./changeOrder.vue?vue&type=script&lang=js&"
import style0 from "./changeOrder.vue?vue&type=style&index=0&id=1b938520&lang=less&scoped=true&"
import style1 from "./changeOrder.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b938520",
  null
  
)

export default component.exports